import { createSlice } from "@reduxjs/toolkit";
// this code for slice value for edit usercontrol
export const EditUsageControl = createSlice({
  name: "EditUsageControl",
  initialState: {
    isLoading: false,
    isSuccess: false,
    api_completed: false,
    isFirst: true,
    switchResponse: false,

    data: [],
  },
  reducers: {
    edit_EditUsageControl: (state, _) => {
      state.isLoading = true;
    },
    success_api_call_EditUsageControl: (state, action) => {
      state.data = action.payload;
      state.isLoading = false;
      state.isSuccess = true;
      state.api_completed = true;
      state.isFirst = true;
      state.switchResponse = true;

    },
    failure_api_call_EditUsageControl: (state, action) => {
      state.isLoading = false;
      state.data = action.payload;
      state.api_completed = true;
      state.isSuccess = false;
      state.switchResponse = true;

    },
    EditUsageControl_is_success: (state) => {
      state.isSuccess = false;
    },
    EditUsageControl_complete_api: (state) => {
      state.api_completed = false;
    },
    clear_EditUsageControl_Data: (state) => {
      state.data = [];
    },

    false_switchEditUsageControl_response: (state) => {
      state.switchResponse = false;
    },
  },
});
export default EditUsageControl.reducer;
export const {
  edit_EditUsageControl,
  success_api_call_EditUsageControl,
  EditUsageControl_complete_api,
  failure_api_call_EditUsageControl,
  EditUsageControl_is_success,
  false_switchEditUsageControl_response
  ,clear_EditUsageControl_Data
} = EditUsageControl.actions;
